export function scrollToReviews(productUid, contextEl = document) {
  const reviewsListEl = contextEl.querySelector(
    `[data-reviews-list-product-uid="${productUid}"]`
  );

  reviewsListEl?.scrollIntoView({ behavior: "smooth" });
}
